<template>
  <div class="pt-5 settings-container">
    <div class="menu-mobile">
      <div @click="$refs.select.click()" class="select">
        <select ref="select" class="standard-select" v-model="activeSettingsId">
          <option
            class="item"
            :value="item.id"
            v-for="(item, i) in [...settings.artist, ...settings.user]"
            :key="i"
          >
            <span class="text">{{ item.title }}</span>
          </option>
        </select>
        <ChevronDownIcon class="pointer-events-none" />
        <span class="focus"></span>
      </div>
    </div>
    <div class="menu">
      <div class="settings-list">
        <div class="title">Artist Settings</div>
        <div class="items">
          <div
            class="item"
            :class="{ active: activeSettingsId === item.id }"
            v-for="(item, i) in settings.artist"
            :key="i"
            @click="openSettings(item.id)"
          >
            <i :class="`icon fa-light ${item.icon} fa-sm`"></i>
            <span class="text">{{ item.title }}</span>
          </div>
        </div>
      </div>
      <div class="settings-list">
        <div class="title">User Settings</div>
        <div class="items">
          <div
            class="item"
            :class="{ active: activeSettingsId === item.id }"
            v-for="(item, i) in settings.user"
            :key="i"
            @click="openSettings(item.id, item.component)"
          >
            <i :class="`icon fa-light ${item.icon} fa-sm`"></i>
            <span class="text">{{ item.title }}</span>
          </div>
        </div>
      </div>
    </div>
    <component :is="activeSettings" v-if="activeSettings" />
  </div>
</template>

<script>
import TrackingPixels from "@/components/Custom/Settings/TrackingPixels.vue";
import TeamMembers from "@/components/Custom/Settings/TeamMembers.vue";
import SocialProfiles from "@/components/Custom/Settings/SocialProfiles.vue";
import ArtistDomain from "@/components/Custom/Settings/ArtistDomain.vue";
import DeleteArtist from "@/components/Custom/Settings/DeleteArtist.vue";
import UserNameEmail from "@/components/Custom/Settings/UserNameEmail.vue";
import UserPassword from "@/components/Custom/Settings/UserPassword.vue";
import Domains from "@/components/Custom/Settings/Domains.vue";
import ItunesAffiliateToken from "@/components/Custom/Settings/ItunesAffiliateToken.vue";
import AgencyMembers from "@/components/Custom/Settings/AgencyMembers.vue";
import ChevronDownIcon from "../../../../public/img/icons/chevron-down.svg";
import Billing from "@/pages/Dashboard/Pages/Billing";

export default {
  name: "Settings",
  components: { ChevronDownIcon },
  data() {
    return {
      activeSettings: TrackingPixels,
      activeSettingsId: "tracking-pixels",
      settings: {
        artist: [
          {
            title: "Tracking Pixels",
            component: TrackingPixels,
            id: "tracking-pixels",
            icon: "fa-chart-line"
          },
          {
            title: "Team Members",
            component: TeamMembers,
            id: "team-members",
            icon: "fa-users"
          },
          {
            title: "Social Profiles",
            component: SocialProfiles,
            id: "social-profiles",
            icon: "fa-share-alt"
          },
          {
            title: "Artist Domain",
            component: ArtistDomain,
            id: "artist-domain",
            icon: "fa-globe"
          },
          {
            title: "Delete Artist",
            component: DeleteArtist,
            id: "delete-artist",
            icon: "fa-trash"
          }
        ],
        user: [
          {
            title: "Name and Email",
            component: UserNameEmail,
            id: "name-and-email",
            icon: "fa-user"
          },
          {
            title: "Update Password",
            component: UserPassword,
            id: "update-password",
            icon: "fa-lock"
          },
          {
            title: "Custom Domains",
            component: Domains,
            id: "custom-domains",
            icon: "fa-globe"
          },
          {
            title: "iTunes Affiliate Token",
            component: ItunesAffiliateToken,
            id: "itunes-affiliate-token",
            icon: "fa-link"
          },
          {
            title: "Billing",
            component: Billing,
            id: "billing",
            icon: "fa-credit-card"
          },
          {
            title: "Agency Members",
            component: AgencyMembers,
            id: "agency-members",
            icon: "fa-building"
          }
          // {
          //   title: "Integrations",
          //   component: null,
          //   id: "integrations"
          // }
        ]
      }
    };
  },
  watch: {
    activeSettingsId(id) {
      this.activeSettings = [
        ...this.settings.artist,
        ...this.settings.user
      ].find(item => item.id === id).component;
    }
  },
  methods: {
    openSettings(id) {
      this.activeSettingsId = id;
      this.$router.push({ query: { tab: id } });
    }
  },
  mounted() {
    if (this.$route.query.tab) {
      this.activeSettingsId = this.$route.query.tab;
    }

    const user = this.$store.getters.getUser;

    if (user.plan !== "agency") {
      this.settings.user = this.settings.user.filter(
        item => item.id !== "itunes-affiliate-token"
      );
    }

    if (user.plan !== "agency") {
      this.settings.user = this.settings.user.filter(
        item => item.id !== "agency-members"
      );
    }
  }
};
</script>
<style lang="scss" scoped>
.settings-container {
  display: flex;
  padding-top: 40px;
  padding-right: 40px;

  .menu {
    // max-width: 300px;
    flex: 1;
    max-width: 240px;
    padding: 0;
    margin: 0 10px;
    flex-direction: column;
    justify-content: start;

    .settings-list {
      border-radius: 8px;
      border: 1px solid $bg-type-2;
      padding: 20px 13px;
      margin-bottom: 20px;

      .title {
        font-size: 18px;
        color: #ffffff;
        font-weight: 600;
        margin-bottom: 22px;
        padding-left: 12px;
      }

      .items {
        .item {
          font-size: 16px;
          cursor: pointer;
          display: flex;
          align-items: center;
          margin: 20px 10px;

          .icon {
            margin-right: 10px;
            width: 14px;
            text-align: center;
          }

          &:hover,
          &.active {
            color: #ffffff;
          }

          &.active {
            font-weight: 600;
            &:before {
              content: "";
              position: absolute;
              z-index: 100;
              left: 8px;
              width: 6px;
              height: 6px;
              background: #9b27af;
              border-radius: 4px;
              -webkit-box-shadow: 0 0 7px #e658ff;
              box-shadow: 0 0 7px #e658ff;
            }
          }

          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
  }

  .content {
    flex: 1;
    padding: 0 0 0 20px !important;
  }
}

@media (max-width: 600px) {
  .settings-container {
    flex-direction: column;

    .menu {
      display: none;
    }

    .menu-mobile {
      padding: 20px;

      .select {
        width: 100%;

        svg {
          top: 16px;
        }
      }
    }

    .content {
      width: 100vw;
      padding: 15px 20px !important;

      table {
        overflow: auto;
      }
    }
  }
}

@media (min-width: 600px) {
  .menu-mobile {
    display: none;
  }
}
</style>
